/**
 * Host-facing catalog copy. Template names and descriptions sometimes carry
 * builder labels (GSAP, PSD, MCP). Strip those on surfaces hosts read.
 * Stored catalog rows stay unchanged.
 */
const JARGON: Array<[RegExp, string]> = [
  [/GSAP ScrollTrigger/gi, ''],
  [/ScrollTrigger/gi, ''],
  [/\bGSAP\b/gi, ''],
  [/PSD-derived/gi, ''],
  [/PSD derived/gi, ''],
  [/PSD Video/gi, 'Video'],
  [/\bPSD\b/gi, ''],
  [/AI-generated/gi, ''],
  [/\bMCP\b/g, ''],
];

export function hostFacingCopy(text: string | null | undefined): string {
  if (!text) return '';
  let out = text;
  for (const [pattern, replacement] of JARGON) {
    out = out.replace(pattern, replacement);
  }
  out = out.replace(/\s{2,}/g, ' ').replace(/\s+([,.:;])/g, '$1').trim();
  // Dropping "AI-generated" can leave "An cinematic…".
  out = out.replace(/\bAn ([bcdfghjklmnpqrstvwxyz])/g, 'A $1');
  return out;
}
